import { axios, API } from './config';

export const reportsAPI = {
  getWeeklySummary: async (date = null) => {
    const params = date ? { date } : {};
    const response = await axios.get(`${API}/reports/weekly-summary`, { params });
    return response.data;
  },
  
  getMonthlySummary: async (year = null, month = null) => {
    const params = {};
    if (year) params.year = year;
    if (month) params.month = month;
    const response = await axios.get(`${API}/reports/monthly-summary`, { params });
    return response.data;
  }
};
